import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XImg = _resolveComponent("XImg")!
  const _component_UploadMenuItem = _resolveComponent("UploadMenuItem")!
  const _component_SearchbarMenuItem = _resolveComponent("SearchbarMenuItem")!

  return (_openBlock(), _createElementBlock("div", {
    id: "mobile-header",
    class: _normalizeClass(["timeline-scroller-gap", {
      visible: !_ctx.isScrollDown,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", { href: _ctx.homeUrl }, [
        _createVNode(_component_XImg, {
          src: _ctx.banner,
          "svg-tag": true
        }, null, 8, ["src"])
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UploadMenuItem),
      _createVNode(_component_SearchbarMenuItem)
    ])
  ], 2))
}